const trimStartFunc = (s, func) => {
	if (!s || !func) {
		return s;
	}
	let start = 0;
	while (start < s.length && func(s.slice(start, start + 1))) {
		start += 1;
	}
	return s.slice(start);
};
const trimEndFunc = (s, func) => {
	if (!s || !func) {
		return s;
	}
	let end = s.length;
	while (end > 0 && func(s.slice(end - 1, end))) {
		end -= 1;
	}
	return s.slice(0, end);
};
const trimFunc = (s, func) => trimStartFunc(trimEndFunc(s, func), func);
const trimStart = (s, spec) => trimStartFunc(s, (str) => str === spec);
const trimEnd = (s, spec) => trimEndFunc(s, (str) => str === spec);
const trim = (s, spec) => trimFunc(s, (str) => str === spec);
const startsWithFold = (path, prefix) => {
	return path.toUpperCase().startsWith(prefix.toUpperCase());
};
const endsWithFold = (path, suffix) => {
	return path.toUpperCase().endsWith(suffix.toUpperCase());
};
const equalsFold = (a, b) => a.toUpperCase() === b.toUpperCase();

export { endsWithFold, equalsFold, startsWithFold, trim, trimEnd, trimEndFunc, trimFunc, trimStart, trimStartFunc };
//# sourceMappingURL=utils.js.map
